import { InitialStateDef } from "@app/types";
export const authErrorHelper = (state: InitialStateDef) => {
  state.user = null;
  state.isAuthenticated = false;
  state.error = true;
  state.loading = false;
};

export const buildTenantAuthority = (tenant: {
  instance?: string;
  tenantId?: string;
}): string | undefined => {
  const instance = tenant.instance?.trim().replace(/\/+$/, "");
  if (!instance) return undefined;
  const hasPath = new URL(instance).pathname.replace(/\/+$/, "") !== "";
  if (!tenant.tenantId || hasPath) return instance;
  return `${instance}/${tenant.tenantId}`;
};
